import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useScrollFreeze } from '@hooks/useScrollFreeze';
import SwitchLink from '../links/switchLink';

import GreenCross from '@svg/greencross.svg';

export const NavPopup = ({ aboutMenu, subNavOpen, setSubNavOpen }) => {
  useScrollFreeze();

  const handleClose = () => setSubNavOpen(false);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className='bg-teal w-full fixed top-0 left-0 z-40'>
      <AnimatePresence>
        <motion.div
          //   key={activeTab}
          initial={{ x: '400%' }}
          animate={{ x: 'calc(100vw - 100%)', transition: { ease: 'linear' } }}
          exit={{ x: '400%', transition: { ease: 'linear' } }}
          className=' fixed left-0 top-0 bg-white w-full max-w-[500px]  h-screen '>
          <div className='relative h-full pb-64 '>
            <div className='space-y-14 flex flex-col text-dark-grey pl-16 mt-40 '>
              <h1 className='text-sm text-green underline underline-offset-8 font-medium'>
                About
              </h1>
              {aboutMenu?.link?.map((item, i) => (
                <SwitchLink
                  key={i}
                  className='blockH6 text-blue hover:opacity-50 transition-all duration-500 ease-in-out'
                  {...item}
                />
              ))}
            </div>
          </div>
          <motion.div
            whileHover={{
              scale: 1.2,
            }}
            onClick={handleClose}
            className='absolute top-10 right-10 cursor-pointer bg-green-tint rounded-full h-10 w-10 '>
            <GreenCross className='w-[16px] absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2' />
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
};
